import { motion } from 'framer-motion';

const steps = [
  { n: '01', title: 'Bewerbung in zwei Minuten', text: 'Ein kurzes Formular ohne Anschreiben mit den wichtigsten Angaben, damit wir dich einordnen können.' },
  { n: '02', title: 'Kennenlerngespräch', text: 'Wir sprechen ehrlich über die Rolle, dein Warum und deine offenen Fragen, ganz ohne Sales Pitch.' },
  { n: '03', title: 'Schnuppertag im Team', text: 'Du verbringst einen Tag bei uns im Büro, erlebst echte Kundengespräche und sprichst mit Beratern, damit beide Seiten ehrlich prüfen können ob es passt.' },
  { n: '04', title: 'Start deiner Ausbildung', text: 'Du startest mit einer strukturierten Einarbeitung an der Seite deines Mentors, machst deine IHK Qualifikationen und übernimmst nach wenigen Monaten deine ersten eigenen Mandate.' },
];

const ProcessSteps = () => {
  return (
    <section className="py-20 md:py-28">
      <div className="container mx-auto px-6">
        <div className="max-w-3xl mb-14">
          <p className="text-[11px] uppercase tracking-[0.22em] text-primary-dark font-semibold mb-4">Dein Weg zu uns</p>
          <h2 className="font-normal text-foreground mb-6">
            Vier Schritte, <span className="italic text-primary-dark">null Bullshit.</span>
          </h2>
          <p className="text-lg text-muted-foreground leading-relaxed">
            Du weißt vorab genau was passiert und musst dich weder durch ein wochenlanges Auswahlverfahren noch durch Assessment Center oder überflüssige Formalitäten arbeiten.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {steps.map((s, i) => (
            <motion.div
              key={s.n}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-60px' }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              className="relative"
            >
              <div className="text-5xl md:text-6xl font-serif text-primary-dark/40 mb-3 leading-none">{s.n}</div>
              <h3 className="font-serif text-xl text-foreground mb-3">{s.title}</h3>
              <p className="text-sm text-muted-foreground leading-relaxed">{s.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProcessSteps;
